// extracted by mini-css-extract-plugin
export default {"informationCard":"InformationCard_informationCard__o5Ejn","informationGrid":"InformationCard_informationGrid__Qx7pZ","informationItem":"InformationCard_informationItem__DKa2Q"};